export interface VideoPlayer {
  play(): void;
  pause(): void;
  stop(): void;
  restart(): void;
  getVideoDuration(): Promise<number>;
  getThumbnailUrl(): Promise<string>;
  hasError(): boolean;
}
